import React, { forwardRef } from 'react';
import moment from 'moment';
import { styled, ButtonBase } from '@mui/material';

import Stack from 'shell/components/Stack';
import Text from 'shell/components/Text';

const CustomButtonBase = styled(ButtonBase)(({ theme }) => {
    return {
        borderRadius: '4px',
        width: '100%',
        height: '4rem',
        padding: theme.spacing(1, 0),
        background: theme.palette.ensightful.shades[0],
        '&:focus': {
            outline: `${theme.palette.ensightful.secondary[100]} solid 3px`,
        },
    };
});

const InnerStack = styled(Stack)(({ workload, theme }) => {
    return {
        width: '100%',
        height: '100%',
        padding: theme.spacing(0, 2),
        ...(workload === 'low' && {
            borderLeft: `3px solid ${theme.palette.ensightful.secondary[400]}`,
        }),
        ...(workload === 'medium' && {
            borderLeft: `3px solid ${theme.palette.ensightful.warning[500]}`,
        }),
        ...(workload === 'high' && {
            borderLeft: `3px solid ${theme.palette.ensightful.error[500]}`,
        }),
    };
});

const TaskStack = styled(Stack)(() => {
    return {
        flex: 1,
        minWidth: 0,
    };
});

export default forwardRef(({ endComponent, getNameById, task, ...rest }, ref) => {
    const today = moment().hour(0).minute(0).second(0).millisecond(0);
    const isOverDue = moment(task.end_on).hour(0).minute(0).second(0).millisecond(0).isBefore(today);

    return (
        <CustomButtonBase ref={ref} component={'div'} role={'presentation'} {...rest}>
            <InnerStack alignItems={'center'} direction={'row'} spacing={1} workload={task.workload}>
                <TaskStack spacing={1}>
                    <Text color={isOverDue ? 'error' : 'default'} noWrap variant={'p3'}>
                        {moment(task.end_on).format('MMM D')}
                        {task.assignee_account_id ? ` - ${getNameById(task.assignee_account_id)}` : ''}
                    </Text>
                    <Text noWrap variant={'p2'}>
                        {task.title}
                    </Text>
                    {task.description && (
                        <Text color={'light'} noWrap rich variant={'p2'}>
                            {task.description}
                        </Text>
                    )}
                </TaskStack>
                {endComponent}
            </InnerStack>
        </CustomButtonBase>
    );
});
